import { db } from "../lib/firebaseApp"
import {
    doc,
    deleteDoc,
    getDocs,
    setDoc,
    collection,
    addDoc,
    serverTimestamp,
    getDoc,
    query,
    where,
    onSnapshot
} from "firebase/firestore";
import { f_recursive_delete } from "./fbFunctions";



// ------------------------------------------------------------------------
export const add_Match = async (user_id, event_id, data, cb_error) => {
    try {
        const docRef = await addDoc(collection(db, "EVENTS", event_id, "MATCHES"), {
            ...data,
            createTimestamp: serverTimestamp(),
            createBy: user_id
        })
        return (docRef.id)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> add_Match:\n", error)
        }
        return(undefined)
    }
}


// ------------------------------------------------------------------------
export const edit_Match = async (user_id, event_id, match_id, data, cb_error) => {
    try {
        const docRef = await setDoc(doc(db, "EVENTS", event_id, "MATCHES", match_id), {
            ...data,
            id: match_id,
            updateTimestamp: serverTimestamp(),
            lastUpdateBy: user_id
        })

        return (docRef)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> edit_Match:\n", error)
        }
        return(undefined)
    }
}

// ------------------------------------------------------------------------
export const delete_Match = async (event_id, match_id, cb_error) => {
    //TODO - delete subcollections data
    try {
            const docSnap = await (getDoc(doc(db, "EVENTS", event_id, "MATCHES", match_id)))
            if (docSnap.exists()) {
                await deleteDoc(doc(db, "EVENTS", event_id, "MATCHES", match_id));
                return (true)
            } else {
                return (false)
            }
        } catch (error) {
            if (cb_error) {
                cb_error(error)
            } else {
                console.error(">>> delete_Match:\n", error)
            }
            return(undefined)
        }
}

// ------------------------------------------------------------------------
export const get_Match_byID = async (event_id, match_id, cb_error) => {
    try {
        const docSnap = await (getDoc(doc(db, "EVENTS", event_id, "MATCHES", match_id)))
        if (docSnap.exists()) {
            const data = docSnap.data()
            const doc = {
                ...data,
                id: docSnap.id,
            }
            return (doc)
        } else {
            return (undefined)
        }
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Match_byID:\n", error)
        }
        return(undefined)
    }
}

// ------------------------------------------------------------------------
export const get_Match_list = async (event_id, cb_error) => {
    try {
        const match_list = []
        const querySnapshot = await getDocs(collection(db, "EVENTS", event_id, "MATCHES"));
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            const match_data = {
                ...data,
                id: doc.id,
            }
            //DEBUG: console.log(doc.id, " => ", match_data);
            match_list.push(match_data)
        });
        return (match_list)
    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_Match_list:\n", error)
        }
        return([])
    }
}






/**
 * get LIVE data for a selected match
 * status is read LIVE from a Document with id = match_id
 * 
 * @param {string} event_id - firebase event id
 * @param {string} match_id - firebase match id
 * @param {update_callback} cb_update - callback function call everytime match data change
 * @param {error_callback} cb_error - callback function call in case of error
 * @return {function } unsubscribe function: has to be called for close LIVE listening
*/
export const get_match_live = async (event_id, match_id, cb_update, cb_error) => {
    try {
        const matchDoc = doc(db, "EVENTS", event_id, "MATCHES", match_id)

        const unsubscribe = onSnapshot(
            matchDoc,
            (snapshot) => {
                const status_data = snapshot.data();
                cb_update(status_data)
            }, (error) => {
                cb_error(error)
            })
        return (unsubscribe)

    } catch (error) {
        if (cb_error) {
            cb_error(error)
        } else {
            console.error(">>> get_match_live:\n", error)
        }
        return (undefined)
    }
}



// ----------------------------------------------------------------------------
/**
 * Cancella la collection MATCHES e tutti documenti "match" al suo interno
 * 
 * @param {string} event_id - id dell'evento da cui cancellare la collection 
 * @returns 
 */
export const clear_all_matches = async (event_id) => {
    console.log("clear_all_matches ", event_id)
    

    const path = "EVENTS/" + event_id + "/MATCHES"
    const res = await f_recursive_delete({ path})
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            return data.path;
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in clear_all_matches cloud function\nError [", code, "]: \n", message, "\n", details)
            return undefined
        });

    return res
}